export const countries = [
  { id: "AE", name: "United Arab Emirates" },
  { id: "AL", name: "Albania" },
  { id: "AT", name: "Austria" },
  { id: "BA", name: "Bosnia and Herzegovina" },
  { id: "BE", name: "Belgium" },
  { id: "BG", name: "Bulgaria" },
  { id: "BH", name: "Bahrain" },
  { id: "BY", name: "Belarus" },
  { id: "CA", name: "Canada" },
  { id: "CY", name: "Cyprus" },
  { id: "CZ", name: "Czech Republic" },
  { id: "DE", name: "Germany" },
  { id: "DK", name: "Denmark" },
  { id: "EE", name: "Estonia" },
  { id: "EG", name: "Egypt" },
  { id: "ES", name: "Spain" },
  { id: "FI", name: "Finland" },
  { id: "FR", name: "France" },
  { id: "GB", name: "United Kingdom" },
  { id: "CH", name: "Switzerland" },
  { id: "GR", name: "Greece" },
  { id: "HR", name: "Croatia" },
  { id: "HU", name: "Hungary" },
  { id: "IE", name: "Ireland" },
  { id: "IL", name: "Israel" },
  { id: "IT", name: "Italy" },
  { id: "JO", name: "Jordan" },
  { id: "LT", name: "Lithuania" },
  { id: "LU", name: "Luxembourg" },
  { id: "LV", name: "Latvia" },
  { id: "MD", name: "Moldova" },
  { id: "ME", name: "Montenegro" },
  { id: "MK", name: "North Macedonia" },
  { id: "MT", name: "Malta" },
  { id: "NL", name: "Netherlands" },
  { id: "PL", name: "Poland" },
  { id: "PT", name: "Portugal" },
  { id: "RO", name: "Romania" },
  { id: "RS", name: "Serbia" },
  { id: "RU", name: "Russian Federation" },
  { id: "SA", name: "Saudi Arabia" },
  { id: "SE", name: "Sweden" },
  { id: "SI", name: "Slovenia" },
  { id: "SK", name: "Slovakia" },
  { id: "UA", name: "Ukraine" },
  { id: "TR", name: "Turkey" },
  { id: "BR", name: "Brazil" },
  { id: "US", name: "Unites States of America" },
  { id: "XK", name: "Kosovo" },
];



// WEBPACK FOOTER //
// ./src/utils/countries.js